import { ComponentRoute } from '@/classes'

const RecurringRemarkRoutes = {
  RecurringRemarkListView: new ComponentRoute('/recurringremarks', 'RecurringRemarkListView'),
  RecurringRemarkView: new ComponentRoute('/recurringremarks/:id', 'RecurringRemarkView'),
  RecurringRemarkDetail: new ComponentRoute('/recurringremarks/:id', 'RecurringRemarkDetail')
}

export default RecurringRemarkRoutes
